import { IRecipe } from "../../models/recipe.models";

import chana_masala from "./chana_masala";
import scrambled_tofu from "./scrambled_tofu";
import butter_chicken from "./butter_chicken";
import shepherds_pie from "./shepherds_pie";
import biscoff_cookies from "./biscoff_cookies";
import meatlovers_pizza from "./meatlovers_pizza";

const testRecipes: Array<IRecipe> = [
  scrambled_tofu,
  butter_chicken,
  shepherds_pie,
  chana_masala,
  biscoff_cookies,
  meatlovers_pizza,
];

export default testRecipes;
